module.exports = __webpack_public_path__ + "static/media/campo_mourao.12cc973e.jpg";